import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme) => ({
  info: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "#667085",
    marginLeft: "10px",
  },
  icon: {
    fontSize: "18px",
  },
  iconButton: {
    padding: "5px",
  },
  itemCenter: {
    display: "flex",
    alignItems: "center",
  },
  locations: {
    backgroundColor: "#F9FAFB",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    width: "100%",
    padding: "16px",
    boxSizing: "border-box",
  },
  formContent: {
    alignSelf: "flex-start",
    margin: 0,
    padding: "5px 1px 0 1px !important",
    width: "100%",
  },
}));

export default styles;
